import { combineEpics, Epic } from 'redux-observable';

import { Action } from '../actions';
import {
    changeColumnsOrder,
    changeColumnsVisibility,
    HANDLE_LOG_COLUMNS_ORDER_CHANGE,
    HANDLE_LOG_COLUMNS_VISIBILITY_CHANGE,
    HANDLE_LOG_COLUMNS_WIDTH_UPDATE,
    HandleLogColumnsOrderChangeAction,
    HandleLogColumnsVisibilityChangeAction,
    HandleLogColumnsWidthUpdateAction,
    updateColumnsWidthData
} from '../actions/log';
import {
    getColumnSettingsWithUpdatedOrder,
    getColumnsVisibilitySettings,
    getColumnsWidthSettings
} from '../service/ActionHelpers';
import { LocalStorage, StorageKeyType } from '../service/Storage/Storage';
import { EpicDeps } from '../service/StoreFactory';
import { logs } from '../typings/common';
import { changedValueKey } from '../typings/log';
import { State } from '../typings/state';

export const handleLogColumnsVisibilityChangeEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$
        .ofType(HANDLE_LOG_COLUMNS_VISIBILITY_CHANGE)
        .map((action: HandleLogColumnsVisibilityChangeAction) => {
            const { columnsSettings } = store$.value.log;
            const settings = getColumnsVisibilitySettings(
                columnsSettings,
                action.columns,
                logs
            );

            LocalStorage.setItem(StorageKeyType.logColumnsSettings, settings);

            return changeColumnsVisibility(settings);
        });
};

export const handleLogColumnsOrderChangeEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$
        .ofType(HANDLE_LOG_COLUMNS_ORDER_CHANGE)
        .map((action: HandleLogColumnsOrderChangeAction) => {
            const { columnsSettings } = store$.value.log;
            const settings = getColumnSettingsWithUpdatedOrder(
                columnsSettings,
                action.columnOrder,
                logs
            );

            LocalStorage.setItem(StorageKeyType.logColumnsSettings, settings);

            return changeColumnsOrder(settings[logs].columnOrder);
        });
};

export const handleLogColumnsWidthUpdateEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$
        .ofType(HANDLE_LOG_COLUMNS_WIDTH_UPDATE)
        .map((action: HandleLogColumnsWidthUpdateAction) => {
            const { columnsSettings } = store$.value.log;
            const settings = getColumnsWidthSettings(
                columnsSettings,
                action.key,
                action.width,
                logs,
                false
            );

            LocalStorage.setItem(StorageKeyType.logColumnsSettings, settings);

            return updateColumnsWidthData(
                settings,
                action.key === changedValueKey ? action.width : undefined
            );
        });
};

export const logHelpers = combineEpics(
    handleLogColumnsVisibilityChangeEpic,
    handleLogColumnsOrderChangeEpic,
    handleLogColumnsWidthUpdateEpic
);
